module.exports = __webpack_public_path__ + "img/mabalise.f5704df4.png";